<template>
    <div class="reaction">
        <div class="reaction__bar">
            <div name="search" class="fab-button" @click="previous">
                Back
            </div>
            <div
                name="heart"
                class="fab-button"
                style="align-self:flex-end"
                @click="likeQuestion"
            >
                Like
            </div>
            <div name="share" class="fab-button" style="align-self:flex-end" @click="drawer = true">
                Share
            </div>
            <div
                name="angle-double-right"
                class="fab-button"
                @click="() => nextRandom()"
            >
                Next
            </div>
        </div>
        <transition name="drawer">
            <Drawer v-if="drawer" v-on:close-drawer="drawer = false" />
        </transition>
    </div>
</template>

<script>
import Drawer from "./Drawer";
import { nextRandom as nr } from "../main";
import { addQuestionToLocalStorage } from "../util/saved";
export default {
    components: {
        Drawer,
    },
    data: function() {
        return {
            drawer: false,
        };
    },
    props: ["currentCard", "inGame", "previous"],
    watch: {
        inGame: function() {
            this.drawer = false;
        },
    },
    methods: {
        nextRandom: function() {
            nr();
        },
        likeQuestion: function() {
            addQuestionToLocalStorage(this.currentCard.id);
        },
    },
};
</script>

<style scoped>
.reactions {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}

.reaction__bar {
    height: 10vh;
    width: 60vh;
    display: flex;
    justify-content: space-around;
    flex-direction: row;
}

.fab-button {
    height: 5vh;
    width: 5vh;
    padding: 5px;
    color: white;
    background: rgb(94, 181, 0);
    background: linear-gradient(
        270deg,
        rgba(94, 181, 0, 1) 0%,
        rgba(0, 166, 238, 1) 100%
    );
    border-radius: 50%;
}

/* Drawer animation */
.drawer-enter-active,
.drawer-leave-active {
    transition: all 0.3s ease-in-out;
}
.drawer-enter,
.drawer-leave-to {
    transform: translateY(90%);
    height: 0;
    opacity: 0;
}
</style>
